import ButtonLink from 'src/components/buttonlink/ButtonLink';
import ISettings from 'src/lib/types/Settings';
import styles from './PromoLinksKgk.module.css';

//#region [Styles]
// Converted to CSS Modules (PromoLinksKgk.module.css) preserving SKGKContainer/SKgkButtonLink.
//#endregion

//#region [Props]
type PromoLinksKgkProps = {
    settings: ISettings;
};
//#endregion

//#region [Component]
export default function PromoLinksKgk({ settings }: PromoLinksKgkProps) {
    if (settings?.showKgkPurchaseLink) {
        return <div className={styles.SKGKContainer}>
            <ButtonLink className={styles.SKgkButtonLink} href='https://kinogavekort.no/?utm_source=Filmweb&utm_medium=meny' inverse target='_blank'>Kjop kinogavekort</ButtonLink>
        </div>;
    }
    return null;
}
//#endregion

